import React from 'react';
import { ResetPassword } from '@planity/ui';
import { useTranslation } from '@planity/localization';

export const ResetPasswordForm = ({
	handleDispatchInputs,
	handleDispatchEvents,
	isPending,
	error,
	password
}) => {
	const { t } = useTranslation();
	const localizedText = {
		title: t(`resetPassword.title`),
		alert: t('resetPassword.alert'),
		label: t('resetPassword.label'),
		placeholder: t(`resetPassword.placeholder`),
		submit: t(`resetPassword.submit`),
		errorMessage: t(`resetPassword.errors.${error}`)
	};
	return (
		<div id='reset-password-form'>
			<ResetPassword
				error={error}
				handleDispatchEvent={handleDispatchEvents}
				handleDispatchInputs={handleDispatchInputs}
				localizedText={localizedText}
				password={password}
				pending={isPending}
			/>
		</div>
	);
};
